import React, { useState } from 'react';
import './header.css';
import Logo from '../../assets/logo.png';
import { Link, useLocation } from 'react-router-dom';


const NavBar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation(); // ✅ gets updated route
  const currentPath = location.pathname;
  //const currentPath = window.location.pathname;

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header>
      <nav>
        <div className="logo">
          <Link to="/"><img src={Logo} alt="RoshTech Logo" /></Link>
        </div>
        <div className="menu-toggle" onClick={toggleMenu}>
          ☰
        </div>
        <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
          <li><Link to="/" className={currentPath === "/" ? 'active' : ''}>Home</Link></li>
          <li><Link to="/about" className={currentPath === '/about' ? 'active' : ''}>About</Link></li>
          <li><Link to="/products" className={currentPath === '/products' ? 'active' : ''}>Products</Link></li>
          <li><Link to="/request-demo" className={currentPath === '/request-demo' ? 'active' : ''}>Request Demo</Link></li>
          <li><Link to="/contact-us" className={currentPath === '/contact-us' ? 'active' : ''}>Contact</Link></li>
        </ul>
      </nav>
    </header>
  );
};

export default NavBar;
